"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSeed = void 0;
/**
 * Get a random number to use as a cache buster in analytics pixel URLs
 * @returns number
 *
 * @internal
 */
function calculateSeed() {
    return Date.now() + Math.floor(1000 * Math.random());
}
exports.calculateSeed = calculateSeed;
//# sourceMappingURL=CalculateSeed.js.map